(function() {
  'use strict';

  let bts = document.querySelectorAll('[data-boxtip]');

  bts.forEach(bt => {
    let btw = getComputedStyle(bt, '::before').getPropertyValue('width').slice(0,-2),
        btml = getComputedStyle(bt, '::before').getPropertyValue('margin-left').slice(0,-2),
        btaml = (+btw + +btml) / 2;

    bt.style.setProperty('--bt-ml', btaml + 'px');
  });

})();
